export default {
  state: {
    all: []
  },
  mutations: {
    SET_SCHEMA (state, schema) {
      state.all = schema
    }
  }
}
